import { useMemo } from 'react';
import { LocationPlaysResponse, SelectedPlatform } from '@/types/api/location';
import { MapDataByPlatform } from './MapDataByPlatform';
import { mixpanelTrack, RevenueDashboardWidget } from '@/utils';
import { MIXPANEL_EVENT } from '@/utils/mixpanelUtils/events';
import LocationMap from './LocationMap';

type Geography = {
  id: string;
  properties: {
    name: string;
  };
  rsmKey: string;
};

const MapChart = ({
  data,
  selectedPlatform,
  handlePlatformChange,
}: {
  data: LocationPlaysResponse;
  selectedPlatform: SelectedPlatform<typeof data>;
  handlePlatformChange: (platform: SelectedPlatform<typeof data>) => void;
}) => {
  const platformData = useMemo(
    () => data.plays.find((play) => play.platform === selectedPlatform)?.country_distribution ?? [],
    [data.plays, selectedPlatform]
  );

  const handleCountryHover = (geography: Geography, plays: number) => {
    mixpanelTrack(MIXPANEL_EVENT.audience.demographics.chartTooltipHover, {
      widget: RevenueDashboardWidget.LocationDemographics,
      page: 'audience',
      platform: selectedPlatform,
      demographics: 'location',
      segment: geography?.properties.name || '',
      plays: plays ? `${plays}` : '0',
    });
  };

  return (
    <div className="flex flex-col xl:flex-row items-center">
      <div className="pr-8 xl:pr-4 flex justify-center w-full xl:w-2/5">
        <LocationMap platformData={platformData} onCountryHover={handleCountryHover} />
      </div>
      <div className="mb-6 flex flex-row items-center justify-center w-full xl:w-3/5">
        <MapDataByPlatform
          data={data}
          selectedPlatform={selectedPlatform}
          handlePlatformChange={handlePlatformChange}
        />
      </div>
    </div>
  );
};

export default MapChart;
